import React, { Component } from 'react'
import { Tenant } from "../components";

export class TenantPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bc : false,
        };
    }

    componentDidMount() {
        this.setBreadcrumb()
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.update===true){
            
        }

        this.setBreadcrumb()
    }

    setBreadcrumb(){
        const { main } = this.props
        const { bc } = this.state
        const { setBreadcrumb } = this.props

        if(bc===false){
            var title = (main.language)? main.language.MENU_TENANT : "-"
            setBreadcrumb(title, [{name:title, link:"/tenant"}])
            this.setState({ bc:true })
        }
    }

    render() {
        return (
            <main>
                <div role="main" className="main">
                    <Tenant {...this.props} />
                </div>
            </main>
        )
    }
}

export default TenantPage
